module.exports = __webpack_public_path__ + "img/qq2.ed3e6f8c.jpg";